import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function BarChart(props) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          //   title: () => null,
          label: function (tooltipItem) {
            var tooltipText = "";
            if (tooltipItem.dataset.data[tooltipItem.dataIndex] != null)
              tooltipText = tooltipItem.dataset.data[tooltipItem.dataIndex];
            if (tooltipText >= 1000) {
              return `${tooltipText / 1000}K`;
            } else {
              return tooltipText;
            }
          },
          labelTextColor: function (context) {
            return "#1A1D1F";
          },
        },
        // displayColors: false,
        titleColor: "#1A1D1F",
        backgroundColor: "#FCFCFC",
        borderColor: "rgba(16, 38, 32, 0.15)",
        borderWidth: 1,
        yAlign: "bottom",
      },
    },
    elements: {
      point: {
        borderWidth: 0,
        radius: 10,
      },
      line: {
        tension: 0.5,
      },
    },
    scales: {
      y: {
        ticks: {
          callback: (label) => {
            if (label >= 1000) {
              return `${label / 1000}K`;
            } else {
              return label;
            }
          },
          padding: 10,
          font: { size: 16, family: "Manrope" },
          color: "#ACB5BB",
        },
        grid: {
          drawTicks: false,
          color: "#343535",
        },
        beginAtZero: true,
      },
      x: {
        ticks: {
          font: { size: 16, family: "Manrope" },
          color: "#ACB5BB",
          padding: 10,
        },

        grid: {
          drawTicks: false,
          display: false, // show/hide grid line in x-axis
          color: "#E9F1E7",
        },
        beginAtZero: true,
      },
    },
  };

  const labels = props.labels;
  const backgroundColors = props.data.map((item, index) =>
    index % 2 === 0 ? "#34C4FF" : "#FF5757"
  );

  const data = {
    labels,
    datasets: [
      {
        data: props.data,
        // borderColor: "#08A708",
        borderRadius: 15,
        backgroundColor: backgroundColors,
        // hoverBackgroundColor: "#102620",
        borderWidth: 0,
        pointBackgroundColor: "rgba(0,0,0,0)",
        pointBorderColor: "rgba(0,0,0,0)",
        barThickness: 43,
      },
    ],
  };
  return <Bar options={options} data={data} />;
}
